import request from '@/utils/request';
import {SDK_VERSION_URL, DOC_URL, PRO_APP_VERSION, SPEED_MY_URL, SPEED_DETAIL_URL, HOME_BANNER_URL} from './api-list';

// 测速app列表
export function sdkVersion(params) {
  return request({
    url: SDK_VERSION_URL,
    method: 'get',
    params: params
  });
}

// 集成文档内容接口
export function docContent(params) {
  return request({
    url: DOC_URL,
    method: 'get',
    params: params
  });
}

// 进行专业版app的下载
export function getProAppVersion(params) {
  return request({
    url: PRO_APP_VERSION,
    method: 'get',
    params: params,
    baseUrlType: 1
  });
}

//获取测速列表
export function getSpeedMy(params) {
  return request({
    url: SPEED_MY_URL,
    method: 'get',
    params: params,
    // baseUrlType: 1
  });
}

//获取测速列表
export function getSpeedDetail(params) {
  return request({
    url: SPEED_DETAIL_URL,
    method: 'get',
    params: params,
  });
}

//获取测速列表
export function getHomeBanner(params) {
  return request({
    url: HOME_BANNER_URL,
    method: 'get',
    params: params,
  });
}
